import React from 'react';
import PropTypes from 'prop-types';

import TransitionModal from 'components/TransitionModal';
import { Container, Title, Subtitle, StyledButton as Button, ButtonContainer } from './styles';

const Alert = ({
  show,
  onClose,
  title,
  subtitle,
  buttonText
}) => (
  <TransitionModal
    show={show}
    onClose={onClose}
  >
    <Container>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <ButtonContainer>
        <Button onClick={onClose}>{buttonText}</Button>
      </ButtonContainer>
    </Container>
  </TransitionModal>
);

Alert.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};

export default Alert;
